import React from 'react';
import PropTypes from 'prop-types';
import PhoneNumberDisplay from 'common/display/PhoneNumberDisplay';
import Email from 'common/display/Email';
import { findPrimaryOrFirst } from 'src/common/utils/utils';
import { isEmpty } from 'lodash';

const ProgramContactCard = ({ contactInfo }) => (
  <div className="col-md-6">
    <div className="p-3">
      <div className="mb-2">
        <strong>Program Name:</strong> {contactInfo.programName}
      </div>
      <div className="mb-2">
        <strong>Organization Name:</strong> {contactInfo.organizationName}
      </div>
      {!isEmpty(contactInfo.phones) && (
        <div className="mb-2 flex items-center">
          <strong>Phone:</strong>
          <div className="ml-1">
            <PhoneNumberDisplay
              item={findPrimaryOrFirst(contactInfo.phones)}
              shortDisplay
              hidePrimaryDisplay
              noLinkStyles={{ className: 'inline-block mt-0' }}
            />
          </div>
        </div>
      )}
      {!isEmpty(contactInfo.emails) && (
        <div className="mb-2 flex items-center">
          <strong>Email:</strong>
          <div className="ml-1">
            <Email
              item={findPrimaryOrFirst(contactInfo.emails)}
              noLink={false}
              shortDisplay
            />
          </div>
        </div>
      )}
      {isEmpty(contactInfo.phones) && isEmpty(contactInfo.emails) && (
        <div className="text-gray-500 italic">
          No listed contact information for this program
        </div>
      )}
    </div>
  </div>
);

ProgramContactCard.propTypes = {
  contactInfo: PropTypes.shape({
    programName: PropTypes.string.isRequired,
    organizationName: PropTypes.string.isRequired,
    phones: PropTypes.array.isRequired,
    emails: PropTypes.array.isRequired,
  }).isRequired,
};

export default ProgramContactCard;
